import React from "react";
import { MessageCircle, MapPin, Phone } from "lucide-react";
import { SITE } from "@/lib/site-data";

export default function Contact() {
  return (
    <section id="contato" className="py-20 md:py-28 bg-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-10 lg:gap-14">
        {/* Left CTA */}
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-orange-600">Vamos conversar</p>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-stone-900" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Agende sua <span className="text-orange-600">consulta.</span>
          </h2>
          <p className="mt-4 text-stone-600 text-lg leading-relaxed max-w-xl">
            Toque no botão abaixo e fale diretamente com a equipe pelo WhatsApp.
            Atendimento rápido, humano e sem complicação.
          </p>

          <a
            href={SITE.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-btn"
            className="mt-8 inline-flex items-center justify-center gap-3 bg-orange-600 hover:bg-orange-700 text-white px-8 py-5 rounded-2xl font-semibold text-lg shadow-[0_15px_40px_rgba(234,88,12,0.35)] hover:-translate-y-0.5 transition-all"
          >
            <MessageCircle className="w-6 h-6" />
            Conversar no WhatsApp
          </a>

          <p className="mt-5 text-sm text-stone-500">
            Resposta em poucos minutos durante o horário de atendimento.
          </p>
        </div>

        {/* Right - info */}
        <div className="space-y-5">
          <div className="rounded-3xl overflow-hidden border border-stone-100 bg-stone-50">
            <iframe
              title="Mapa Google"
              src={SITE.mapsEmbed}
              className="w-full h-72 border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <InfoRow icon={<MapPin className="w-5 h-5" />} label="Endereço" value={SITE.address.full} />
          <InfoRow icon={<Phone className="w-5 h-5" />} label="Telefone" value={SITE.phone} href={`tel:+55${SITE.whatsappRaw}`} />
          <InfoRow icon={<MessageCircle className="w-5 h-5" />} label="WhatsApp" value="Conversar no WhatsApp" href={SITE.whatsappLink} />
        </div>
      </div>
    </section>
  );
}

function InfoRow({ icon, label, value, href }) {
  const Wrap = href ? "a" : "div";
  return (
    <Wrap href={href} target={href ? "_blank" : undefined} rel="noopener noreferrer" className="flex items-start gap-4 p-5 rounded-2xl bg-stone-50 border border-stone-100 hover:border-orange-200 transition-colors group">
      <div className="h-11 w-11 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center shrink-0">{icon}</div>
      <div>
        <div className="text-xs uppercase tracking-wider text-stone-500 font-bold">{label}</div>
        <div className="mt-1 text-stone-800 font-medium group-hover:text-orange-600 transition-colors break-all">{value}</div>
      </div>
    </Wrap>
  );
}
